import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import classNames from 'classnames';

import { FeatureFlag } from 'app/api/services/site-configs/types';

import { useFeatureFlag } from 'app/lib/feature-flags';
import { createAuthQuery } from 'app/modules/SigningNew/utils/auth-modals-query';

import { AuthContext } from '../../context';
import { AuthorizationBody, AuthorizationBodyWithFP } from '../AuthorizationModal/AuthorizationBody';
import { AuthorizationFooter } from '../AuthorizationModal/AuthorizationFooter';
import { Header } from '../Header';
import { Signing } from '../Signing/Signing';

import styles from './SignModal.module.scss';

export const SignContent = () => {
  const {
    authData: { shake },
  } = useContext(AuthContext);
  const { search } = useLocation();
  const isSign = search.startsWith(createAuthQuery('sign'));
  const isLoginTab = search.startsWith(createAuthQuery('login'));
  const isFingerprint = useFeatureFlag(FeatureFlag.FINGERPRINT);

  const contentClassnames = classNames(styles.loginModalContent, {
    [styles.shake]: shake,
  });

  return (
    <div className={contentClassnames}>
      <Header />

      {isLoginTab && (
        <>
          {isFingerprint ? <AuthorizationBodyWithFP /> : <AuthorizationBody />}
          <AuthorizationFooter />
        </>
      )}

      {isSign && (
        <Signing />
      )}
    </div>
  );
};
